import { urls } from "../constants";
import { Get } from "../fetch";
export async function loadFeatureFlags() {
  return Get(urls.featureFlags.v1);
}